import styled from "styled-components";
import colors from "../../../../css/colors";

interface SectionCardProps {
  isEditing?: boolean;
}

export const SectionCard = styled.div<SectionCardProps>`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: ${(props) => (props.isEditing ? "24px" : 0)};
  max-width: 100%;
  background-color: ${colors.WHITE};
  border: 1px solid ${colors.GREY_LIGHT};
  border-radius: 4px;
  overflow: auto;

  .ant-table-tbody > tr > td {
    border-bottom: ${(props) => (props.isEditing ? "1px solid #f0f0f0" : "none")};
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

interface SearchWrapperProps {
  width?: number;
}

export const SearchWrapper = styled.div<SearchWrapperProps>`
  margin: 0 0 24px;
  width: ${(props) => (props.width ? `${props.width}px` : "initial")};
`;
